import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { getFirebaseAuth } from '../../lib/firebase';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Banner } from '../../components/Banner';
import { AuthShell } from './AuthShell';

// R1.9: el mensaje es idéntico exista o no el email, para no revelar cuentas.
export const RECOVERY_SENT_MESSAGE = 'Si el email tiene una cuenta, te enviamos un enlace de un solo uso. Vence en 1 hora.';

export function RecoverPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [networkError, setNetworkError] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setNetworkError(false);
    try {
      await sendPasswordResetEmail(getFirebaseAuth(), email.trim());
      setSent(true);
    } catch (err) {
      const code = (err as { code?: string }).code;
      if (code === 'auth/network-request-failed') setNetworkError(true);
      else setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell title="Recuperar contraseña">
      {sent ? (
        <div className="space-y-4">
          <Banner tone="success">{RECOVERY_SENT_MESSAGE}</Banner>
          <Link to="/login" className="text-sm">
            Volver a iniciar sesión
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          {networkError && <Banner tone="error">No pudimos conectarnos. Revisa tu conexión.</Banner>}
          <Input label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" block size="lg" loading={loading} disabled={!email}>
            Enviar enlace
          </Button>
          <p className="text-center text-sm">
            <Link to="/login">Volver</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
